// assets/jb-calc.js
(function () {
  /* ---------- Utils ---------- */
  function safeParse(s) { try { return JSON.parse(s); } catch { return {}; } }
  function debounce(fn, delay) { let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), delay); }; }
  // helper: simple email check
  function isValidEmail(e){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e).trim()); }

  /* ---------- Enhance one calculator root ---------- */
  function enhance(root) {
    if (!root || root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    // 1) Dynamic data (from metafield/theme) — REQUIRED (no fallback)
    const cfg = safeParse(root.dataset.config || '{}');
    if (!cfg || Object.keys(cfg).length === 0) {
      console.warn('JB Calc: missing product pricing metafield (custom.b2b_pricing). Skipping.');
      return; // don’t enhance if there’s no data
    }
    const PRICING = cfg;

    const MAPBOX_TOKEN = root.dataset.mapboxToken || '';
    const MAX_SHOWN_QTY = 500;

    // 2) Scoped selectors
    const $ = (sel) => root.querySelector(sel);
    const elCurrency   = $('#jb-calc-currency');
    const elQty        = $('#jb-calc-qty');
    const elPrint      = $('#jb-calc-print');
    const elUnit       = $('#jb-calc-unit');
    const elTotal      = $('#jb-calc-total');
    const elImpact     = $('#jb-calc-impact');
    const elExVat      = $('#jb-exvat');
    const elRrpRow     = $('#jb-rrp-row');
    const elRrp        = $('#jb-calc-rrp');
    const coBrandPill  = $('#jb-cobrand-pill');

    // Shipping (scoped)
    const shipCity     = $('#jb-ship-city');
    const shipBtn      = $('#jb-ship-check');
    const shipStatus   = $('#jb-ship-status');
    const suggestBox   = $('#jb-ship-suggest');

    /* ---------- Persist user choices per product ---------- */
    const storageKey = (function(){
      function getProductKey(){
        const cands = [
          root.dataset.productId,
          root.dataset.productHandle,
          window.ShopifyAnalytics?.meta?.product?.id,
          window.ShopifyAnalytics?.meta?.product?.handle,
          window.meta?.product?.id,
          window.meta?.product?.handle
        ].filter(Boolean);
        if (cands.length) return String(cands[0]);
        try {
          const m = location.pathname.match(/\/products\/([^\/?#]+)/i);
          if (m) return decodeURIComponent(m[1]);
        } catch {}
        return location.pathname || 'global';
      }
      return `jbcalc:v2:${getProductKey()}`;
    })();
    let prefs = {};
    try { prefs = JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch {}
    function persist(){
      try {
        const data = {
          cur:   elCurrency?.value || '',
          qty:   elQty?.value || '',
          print: elPrint?.value || ''
        };
        localStorage.setItem(storageKey, JSON.stringify(data));
      } catch {}
    }

    /* ---------- Email Gate (optional via data-gate="email") ---------- */
    const gateEnabled = (root.dataset.gate || '').toLowerCase() === 'email';

    // sitewide key so unlocking works across all products (per browser/device)
    const productKey = 'sitewide';
    const gateKey  = `jbcalc:gate:${productKey}`;
    const emailKey = `jbcalc:email:${productKey}`;

    /* ---------- GA4 pricing unlock tracking ---------- */
const UNLOCK_EVENT_KEY = 'jbcalc:ga:pricing_unlocked'; // sitewide "fire once" key

function addPricingUnlockedParam() {
  try {
    const url = new URL(window.location.href);
    // keep UTMs etc. and just add our flag
    url.searchParams.set('pricing_unlocked', '1');
    history.replaceState({}, '', url.toString());
  } catch {}
}

function firePricingUnlockedEventOnce() {
  try {
    // only fire once per browser (sitewide)
    if (localStorage.getItem(UNLOCK_EVENT_KEY) === '1') return;

    // GA event removed — handled via GTM


    localStorage.setItem(UNLOCK_EVENT_KEY, '1');
  } catch {}
}


    function unlockGate() {
      try { localStorage.setItem(gateKey, '1'); } catch{}
      root.classList.remove('jb-gated');
      gateEl?.remove();
      // (removed auto-focus to prevent page scrolling)
    }

    // send a simple email via Shopify's /contact form
    function notifyOwner(email){
      const title  = root.dataset.productTitle
                  || window.meta?.product?.title
                  || document.querySelector('meta[property="og:title"]')?.content
                  || document.title;

      const handle = root.dataset.productHandle
                  || window.meta?.product?.handle
                  || '';

      const msg = [
        'B2B calculator unlocked',
        `Email: ${email}`,
        `Product: ${title}`,
        `Handle: ${handle}`,
        `URL: ${location.href}`,
        `Time: ${new Date().toISOString()}`
      ].join('\n');

      const params = new URLSearchParams();
      params.set('form_type','contact');
      params.set('utf8','✓');
      params.set('contact[email]', email);
      params.set('contact[body]', msg);

      // fire-and-forget; keepalive helps if they navigate away
      fetch('/contact#contact_form', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: params.toString(),
        credentials: 'same-origin',
        keepalive: true
      }).catch(()=>{});
    }

    let gateEl = null;
    if (gateEnabled && localStorage.getItem(gateKey) !== '1') {
      root.classList.add('jb-gated');

      gateEl = document.createElement('div');
      gateEl.className = 'jb-gate';
      gateEl.innerHTML = `
        <div class="jb-gate-backdrop" aria-hidden="true"></div>
        <div class="jb-gate-card" role="dialog" aria-modal="true" aria-labelledby="jb-gate-title">
          <h4 id="jb-gate-title" class="jb-gate-title">See B2B Pricing</h4>
          <p class="jb-gate-sub">Enter your work email to unlock business pricing</p>
          <div class="jb-gate-row">
            <input type="email" class="jb-gate-input" placeholder="name@company.com" autocomplete="email" required>
            <button class="jb-gate-btn" type="button">View Pricing</button>
          </div>
          <div class="jb-gate-error" aria-live="polite"></div>
        </div>
      `;
      root.appendChild(gateEl);

      const emailInput = gateEl.querySelector('.jb-gate-input');
      const btn        = gateEl.querySelector('.jb-gate-btn');
      const err        = gateEl.querySelector('.jb-gate-error');

      const submit = async () => {
        const email = String(emailInput.value || '').trim();
        if (!isValidEmail(email)) { err.textContent = 'Please enter a valid email'; emailInput.focus(); return; }
        err.textContent = ''; btn.disabled = true;

        // OPTION A: store & unlock
        try { localStorage.setItem(emailKey, email); } catch {}
        notifyOwner(email);
        unlockGate();
        addPricingUnlockedParam();
        firePricingUnlockedEventOnce();
      };

      btn.addEventListener('click', submit);
      emailInput.addEventListener('keydown', (e)=>{ if (e.key === 'Enter') submit(); });
    }

    // If already unlocked (returning visitor), ensure URL flag exists (no reload)
if (gateEnabled && localStorage.getItem(gateKey) === '1') {
  addPricingUnlockedParam();
}

    /* ---------- Currency select with symbols ---------- */
    function currencyKeys() {
      return Object.keys(PRICING).filter(k => PRICING[k] && typeof PRICING[k] === 'object' && PRICING[k].unit);
    }
    function currencyLabel(code, meta) {
      const c = (meta && meta.code) ? meta.code : code;
      const locale = meta && meta.locale ? meta.locale : undefined;
      try {
        const nf = new Intl.NumberFormat(locale, { style: 'currency', currency: c, currencyDisplay: 'symbol' });
        const parts = nf.formatToParts(0);
        const sym = parts.find(p => p.type === 'currency')?.value;
        return sym ? `${code} ${sym}` : code;
      } catch {
        return code;
      }
    }
    function buildCurrencySelect() {
      if (!elCurrency) return;
      elCurrency.innerHTML = '';
      const codes = currencyKeys();
      codes.forEach(code => {
        const opt = document.createElement('option');
        opt.value = code;
        opt.textContent = currencyLabel(code, PRICING[code]);
        elCurrency.appendChild(opt);
      });

      // Priority: saved pref -> HTML default -> GBP -> first
      const saved   = (prefs.cur || '').toUpperCase();
      const desired = (root.dataset.defaultCurrency || '').toUpperCase();
      if (saved && codes.includes(saved)) {
        elCurrency.value = saved;
      } else if (desired && codes.includes(desired)) {
        elCurrency.value = desired;
      } else if (codes.includes('GBP')) {
        elCurrency.value = 'GBP';
      } else {
        elCurrency.value = codes[0] || '';
      }
    }
    buildCurrencySelect();

    /* ---------- Print select: build from metafield ---------- */
    function getPrintKeys() {
      const sets = currencyKeys().map(k => Object.keys((PRICING[k]||{}).surcharge || {}));
      return Array.from(new Set(sets.flat()));
    }
    const PRINT_LABELS = (PRICING.labels && PRICING.labels.prints) || {
      laser: 'Laser Engrave',
      colour: 'ColourLift™ Print',
      wrap: 'Wrap Printing',
      multicolour: 'Multi colour print'
    };
    const PRINT_TIPS = (PRICING.tooltips && PRICING.tooltips.prints) || {
      laser: 'Exposes the stainless steel below',
      colour: 'Premium quality print for single colour designs',
      wrap: '360 degree printing around the cup',
      multicolour: 'Limitless colour printing'
    };
    function labelForPrint(key){
      return PRINT_LABELS[key] || key.replace(/_/g,' ').replace(/\b\w/g, m => m.toUpperCase());
    }
    function buildPrintSelect(){
      if (!elPrint) return;
      const keys = getPrintKeys();
      if (!keys.length) return; // leave any static options if metafield omitted
      elPrint.innerHTML = '';
      keys.forEach(k => {
        const opt = document.createElement('option');
        opt.value = k;
        opt.textContent = labelForPrint(k);
        elPrint.appendChild(opt);
      });
      if (prefs.print && keys.includes(prefs.print)) {
        elPrint.value = prefs.print;
      } else if (keys.includes('laser')) {
        elPrint.value = 'laser';
      } else {
        elPrint.value = keys[0];
      }
    }
    buildPrintSelect();

    /* ---------- Print tooltip (“i”) ---------- */
    const printLabelSpan = elPrint ? elPrint.closest('label')?.querySelector('.jb-calc-label') : null;
    let tipBtn, tipBubble;

    function buildTipContent() {
      const keys = getPrintKeys(); // available across this product
      const items = keys.map(k => {
        const name = labelForPrint(k);
        const blurb = PRINT_TIPS[k] || 'Details available on request.';
        const esc = (s)=>String(s).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
        return `<li><strong>${esc(name)}:</strong> ${esc(blurb)}</li>`;
      }).join('');
      return `<ul class="jb-tip-list">${items}</ul>`;
    }

    if (printLabelSpan) {
      tipBtn = document.createElement('button');
      tipBtn.type = 'button';
      tipBtn.className = 'jb-tip';
      tipBtn.setAttribute('aria-expanded','false');
      tipBtn.setAttribute('aria-label','About print options');
      tipBtn.innerHTML = 'i';

      tipBubble = document.createElement('div');
      tipBubble.className = 'jb-tip-bubble';
      tipBubble.setAttribute('role','tooltip');
      tipBubble.hidden = true;
      tipBubble.innerHTML = buildTipContent();

      printLabelSpan.appendChild(tipBtn);
      printLabelSpan.appendChild(tipBubble);

      const hideTip = () => { tipBtn.setAttribute('aria-expanded','false'); tipBubble.hidden = true; };
      const showTip = () => { tipBtn.setAttribute('aria-expanded','true');  tipBubble.hidden = false; };
      const toggleTip = () => (tipBtn.getAttribute('aria-expanded') === 'true' ? hideTip() : showTip());

      // Hover + focus for desktop/keyboard, click as mobile fallback
      tipBtn.addEventListener('mouseenter', showTip);
      tipBtn.addEventListener('mouseleave', hideTip);
      tipBtn.addEventListener('focus', showTip);
      tipBtn.addEventListener('blur', hideTip);
      tipBtn.addEventListener('click', (e)=>{ e.preventDefault(); toggleTip(); });

      // Close if clicking elsewhere within this calc
      root.addEventListener('click', (e) => {
        if (e.target !== tipBtn && !tipBubble.contains(e.target)) hideTip();
      });
    }

    /* ---------- Breakpoint nudge container (auto-injected) ---------- */
    let nudgeEl = root.querySelector('.jb-nudge');
    if (!nudgeEl) {
      nudgeEl = document.createElement('div');
      nudgeEl.className = 'jb-nudge is-hidden';
      const grid = root.querySelector('.jb-calc-grid');
      (grid || root).insertAdjacentElement('afterend', nudgeEl);
    }

    /* ---------- Restore saved quantity (if available) ---------- */
    if (elQty && prefs.qty && [...elQty.options].some(o => o.value === prefs.qty)) {
      elQty.value = prefs.qty;
    }

    /* ---------- Calculator helpers ---------- */
    function firstCurrencyKey(){ const k = currencyKeys(); return k.length ? k[0] : null; }
    function fmt(amount, meta) {
      const code = meta?.code;
      const locale = meta?.locale;
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: code, maximumFractionDigits: 2 }).format(amount); }
      catch { return amount.toFixed(2); }
    }
    function nearestTier(qty, table) {
      const tiers = Object.keys(table.unit).map(Number).sort((a,b)=>a-b);
      for (let i = tiers.length - 1; i >= 0; i--) if (qty >= tiers[i]) return tiers[i];
      return tiers[0];
    }
    function nextTierAbove(qty, table) {
      const tiers = Object.keys(table.unit).map(Number).sort((a,b)=>a-b);
      for (let i = 0; i < tiers.length; i++) if (tiers[i] > qty) return tiers[i];
      return null;
    }
    function updateRrp(meta, unitPrice) {
      if (!elRrpRow || !elRrp) return;
      const rrp = meta.rrp || 0;
      if (!rrp || !unitPrice || unitPrice >= rrp) { elRrpRow.classList.add('is-hidden'); return; }
      elRrp.textContent = fmt(rrp, meta);
      elRrpRow.classList.remove('is-hidden');
    }
    function toggleExVat(show) { if (elExVat) elExVat.classList.toggle('is-hidden', !show); }

    // Subtle figure fade
    function setFigure(el, text){
      if (!el) return;
      if (el.textContent !== text){
        el.textContent = text;
        el.classList.remove('jb-fig-anim');
        // reflow to restart animation
        // eslint-disable-next-line no-unused-expressions
        el.offsetWidth;
        el.classList.add('jb-fig-anim');
      }
    }

    // Pill flash
    let prevUnitPrice = null, priceSeeded = false;
    function flashCoBrandPill() {
      if (!coBrandPill) return;
      coBrandPill.classList.remove('is-flash'); // reset
      // reflow to restart animation
      // eslint-disable-next-line no-unused-expressions
      coBrandPill.offsetWidth;
      coBrandPill.classList.add('is-flash');
    }
    coBrandPill && coBrandPill.addEventListener('animationend', () => coBrandPill.classList.remove('is-flash'));

    // Add near other helpers
    function flashImpactBar(elImpact){
      const card = elImpact?.closest('.jb-impact');
      if (!card) return;
      card.classList.remove('is-flash');
      // force a reflow so the animation restarts
      void card.offsetWidth;
      card.classList.add('is-flash');
    }

    /* ---------- Main calc ---------- */
    function calc() {
      // Pick a valid currency from PRICING
      let curKey = elCurrency?.value;
      if (!curKey || !PRICING[curKey] || !PRICING[curKey].unit) {
        curKey = firstCurrencyKey(PRICING);
        if (elCurrency && curKey) elCurrency.value = curKey; // sync the UI if needed
      }
      const curr = PRICING[curKey];
      if (!curr) return;

      // Ensure meta has code/locale even if missing in metafield
      const meta = { ...curr, code: curr.code || curKey, locale: curr.locale || undefined };

      const qtyVal = elQty?.value || '0';
      const isPlus = qtyVal === '500plus';
      const qty = isPlus ? MAX_SHOWN_QTY + 1 : parseInt(qtyVal, 10) || 0;

      // Resolve print value robustly from available keys
      const availablePrints = getPrintKeys();
      let print = elPrint?.value;
      if (!print || (availablePrints.length && !availablePrints.includes(print))) {
        print = availablePrints[0] || 'laser';
        if (elPrint) elPrint.value = print;
      }

      // Impact: 0.1 kg per unit
      const impactText = isPlus ? (MAX_SHOWN_QTY * 0.1).toFixed(1) + '+ kg' : (qty * 0.1).toFixed(1) + ' kg';
      if (elImpact) { elImpact.textContent = impactText; flashImpactBar(elImpact); }

      const isQuote = qty > MAX_SHOWN_QTY;
      toggleExVat((meta.code === 'GBP') && !isQuote);

      if (isQuote) {
        setFigure(elUnit,  'Quote'); elUnit?.classList.add('jb-quote');
        setFigure(elTotal, 'Quote'); elTotal?.classList.add('jb-quote');
        if (elRrpRow) elRrpRow.classList.add('is-hidden');
        nudgeEl && nudgeEl.classList.add('is-hidden');
      } else {
        const tier  = nearestTier(qty, meta);
        const unit  = (meta.unit[tier] || 0) + ((meta.surcharge && meta.surcharge[print]) || 0);
        const total = unit * qty;

        setFigure(elUnit,  fmt(unit, meta));  elUnit?.classList.remove('jb-quote');
        setFigure(elTotal, fmt(total, meta)); elTotal?.classList.remove('jb-quote');

        updateRrp(meta, unit);

        // 🔹 Breakpoint nudge
        const nextTier = nextTierAbove(qty, meta);
        if (nudgeEl && nextTier && qty < nextTier) {
          const nextUnit = (meta.unit[nextTier] || 0) + ((meta.surcharge && meta.surcharge[print]) || 0);
          const savePer = unit - nextUnit;
          const delta   = nextTier - qty;
          if (savePer > 0) {
            nudgeEl.innerHTML = `Order <strong>${delta}</strong> more to hit the next price break (save <strong>${fmt(savePer, meta)}</strong>/unit)`;
            nudgeEl.classList.remove('is-hidden');
          } else {
            nudgeEl.classList.add('is-hidden');
          }
        } else {
          nudgeEl && nudgeEl.classList.add('is-hidden');
        }

        if (priceSeeded && (prevUnitPrice === null || Math.abs(unit - prevUnitPrice) > 1e-6)) {
          flashCoBrandPill();
        }
        prevUnitPrice = unit; priceSeeded = true;
      }

      // Save current choices
      persist();
    }

    /* ---------- Shipping: Mapbox autocomplete (unchanged) ---------- */
    let activeIndex = -1;
    let suggestions = [];
    let selectedPlace = null; // { city, country, country_code }

    function openSuggest() { suggestBox?.classList.add('is-open'); shipCity?.setAttribute('aria-expanded', 'true'); }
    function closeSuggest(){ suggestBox?.classList.remove('is-open'); shipCity?.setAttribute('aria-expanded', 'false'); activeIndex = -1; }
    function renderSuggestions(items) {
      suggestions = items || [];
      if (!suggestBox) return;
      suggestBox.innerHTML = '';
      if (!items.length) { closeSuggest(); return; }
      const frag = document.createDocumentFragment();
      items.forEach((it, idx) => {
        const li = document.createElement('li');
        li.setAttribute('role','option');
        li.setAttribute('id', 'jb-sugg-' + idx);
        li.dataset.index = String(idx);

        const c = document.createElement('span'); c.className='jb-suggest-city'; c.textContent = it.city;
        const r = document.createElement('span'); r.className='jb-suggest-country'; r.textContent = it.country;
        li.appendChild(c); li.appendChild(r);

        li.addEventListener('mousedown', (e)=>{ e.preventDefault(); selectSuggestion(idx); });
        frag.appendChild(li);
      });
      suggestBox.appendChild(frag);
      openSuggest();
      highlight(-1);
    }
    function highlight(idx) {
      activeIndex = idx;
      if (!suggestBox) return;
      [...suggestBox.children].forEach((el,i)=>{ el.setAttribute('aria-selected', i===idx ? 'true' : 'false'); });
    }
    function selectSuggestion(idx) { const it = suggestions[idx]; if (!it) return; selectedPlace = it; if (shipCity) shipCity.value = it.city; closeSuggest(); }
    function escapeHtml(str) { return String(str).replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m])); }

    async function fetchPlaces(q) {
      if (!MAPBOX_TOKEN) return [];
      const url = new URL(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(q)}.json`);
      url.searchParams.set('types','place,locality');
      url.searchParams.set('autocomplete','true');
      url.searchParams.set('limit','6');
      url.searchParams.set('language','en');
      url.searchParams.set('access_token', MAPBOX_TOKEN);

      const res = await fetch(url.toString());
      if (!res.ok) throw new Error('Mapbox error');
      const data = await res.json();
      const out = (data.features || []).map(f => {
        const city = f.text || f.place_name || '';
        let country = ''; let cc = '';
        if (Array.isArray(f.context)) {
          for (const c of f.context) {
            if (c.id && c.id.startsWith('country')) { country = c.text || ''; cc = (c.short_code || '').toUpperCase(); }
          }
        }
        if (!country && f.properties && (f.properties.short_code || f.properties.country)){
          cc = (f.properties.short_code || '').toUpperCase();
          country = f.properties.country || country;
        }
        return { city, country, country_code: cc || '', place_name: f.place_name || '' };
      }).filter(x => x.city);
      return dedupePlaces(out);
    }
    function dedupePlaces(list) {
      const seen = new Set(); const out = [];
      for (const it of list) { const key = `${it.city}|${it.country_code}`; if (!seen.has(key)) { seen.add(key); out.push(it); } }
      return out;
    }
    const searchPlaces = debounce(async (q) => {
      selectedPlace = null;
      try { if (!q || q.trim().length < 2) { renderSuggestions([]); return; }
        const items = await fetchPlaces(q.trim()); renderSuggestions(items);
      } catch { renderSuggestions([]); }
    }, 250);
    function setStatusVerified(place) {
      shipStatus?.classList.remove('is-loading');
      if (shipStatus) shipStatus.innerHTML = `<span class="jb-ship-free-badge">Free Delivery</span> to <strong>${escapeHtml(place.city)}</strong>`;
    }
    function setStatusNeutral() { shipStatus?.classList.remove('is-loading'); if (shipStatus) shipStatus.textContent = 'Please click on your city, then press enter or check'; }
    function checkShipping() {
      if (!shipStatus) return;
      shipStatus.classList.add('is-loading'); shipStatus.textContent = 'Checking your city…';
      if (shipBtn) shipBtn.disabled = true; if (shipCity) shipCity.disabled = true;
      setTimeout(() => {
        if (selectedPlace && shipCity && shipCity.value.trim().toLowerCase() === selectedPlace.city.trim().toLowerCase()){
          setStatusVerified(selectedPlace);
        } else { setStatusNeutral(); }
        if (shipBtn) shipBtn.disabled = false; if (shipCity) shipCity.disabled = false;
      }, 950);
    }
    function shipCityKeydownHandler(e) {
      const open = suggestBox?.classList.contains('is-open');
      if (open && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
        e.preventDefault();
        const max = suggestions.length - 1;
        if (e.key === 'ArrowDown') highlight(activeIndex < max ? activeIndex + 1 : 0);
        else highlight(activeIndex > 0 ? activeIndex - 1 : max);
        return;
      }
      if (e.key === 'Escape') { closeSuggest(); return; }
      if (e.key === 'Enter') {
        e.preventDefault();
        if (open) { if (activeIndex >= 0) selectSuggestion(activeIndex); else if (suggestions.length > 0) selectSuggestion(0); }
        else {
          if ((!selectedPlace || (shipCity && shipCity.value.trim().toLowerCase() !== selectedPlace.city.trim().toLowerCase()))
              && suggestions.length > 0) { selectSuggestion(0); }
        }
        checkShipping();
      }
    }

    /* ---------- Bind events (scoped) ---------- */
    elCurrency && elCurrency.addEventListener('input', () => { persist(); calc(); });
    elQty      && elQty.addEventListener('input',      () => { persist(); calc(); });
    elPrint    && elPrint.addEventListener('input',    () => { persist(); calc(); }); // tooltip shows all; no per-selection update

    shipBtn    && shipBtn.addEventListener('click',    checkShipping);
    shipCity   && shipCity.addEventListener('input',   (e)=>searchPlaces(e.target.value));
    shipCity   && shipCity.addEventListener('keydown', shipCityKeydownHandler);

    // Close suggestions when clicking outside (within this root)
    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) return;
      if (suggestBox && !suggestBox.contains(e.target) && e.target !== shipCity) closeSuggest();
    });

    // Init
    calc();
  }

  /* ---------- Boot for all instances ---------- */
  function boot() {
    document.querySelectorAll('.jb-calc-root').forEach(enhance);
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);

  // ✅ Re-init when themes dynamically swap sections (variant changes, quick shop, etc.)
  (function observeDynamicUpdates(){
    if (window.__jbCalcObserved) return; // guard against double observers
    window.__jbCalcObserved = true;

    const mo = new MutationObserver((mutations) => {
      let shouldBoot = false;

      for (const m of mutations) {
        if (m.type === 'childList') {
          for (const n of m.addedNodes) {
            if (n.nodeType !== 1) continue;
            if (n.matches?.('.jb-calc-root') || n.querySelector?.('.jb-calc-root')) {
              shouldBoot = true; break;
            }
          }
        }
        if (m.type === 'attributes'
            && m.target.classList?.contains('jb-calc-root')
            && (m.attributeName === 'data-config' || m.attributeName === 'data-default-currency')) {
          delete m.target.dataset.ready;
          enhance(m.target);
        }
        if (shouldBoot) break;
      }

      if (shouldBoot) boot();
    });

    mo.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-config','data-default-currency']
    });

    // Also listen for common theme events some themes dispatch on variant change
    document.addEventListener('variant:changed', boot);
    document.addEventListener('product:change', boot);
  })();
})();
